module.exports = __webpack_public_path__ + "img/momo_home_bg_1.506df388.png";